L.Control.TouchAndHoldNotice = L.Control.extend({

    show: function() {

        var container = L.DomUtil.create('div', 'touch-and-hold-notice', document.body);

        var text = L.DomUtil.create('span', '', container);
        text.innerHTML = L.localisation.get('popup.touchAndHold');

        var link = L.DomUtil.create('i', 'fa fa-times touch-and-hold-close', container);
        L.DomEvent.on(link, 'click', L.bind(function(e) {
            container.style.display = 'none';
            L.DomEvent.preventDefault(e);
        }, this));
    }
});

